import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const create = async ({ data, outsourcedDpoId = '' }) =>
  await dponetAPI.post(`/fantasy_dpos`, {
    outsourcedDpoId: outsourcedDpoId,
    fantasyDpos: data.fantasyDpos,
  })

const manage = async ({ data, outsourcedDpoId = '' }) =>
  await dponetAPI.put(`/fantasy_dpos/manage`, {
    outsourcedDpoId: outsourcedDpoId,
    fantasyDpos: data.fantasyDpos,
  })

const fantasyDpos = {
  create,
  manage,
}

export default fantasyDpos
